@if(savingForm){
<create-account-placeholder-component [formName]="data.title"></create-account-placeholder-component>
}
<div
  class="app__itemCard app__solid--border rounded-xl bg-white border-[#e2e4e5] px-[26px] py-[18px] w-[636px]"
  [ngClass]="savingForm ? 'h-0 invisible absolute w-0' : visibility ? 'relative overflow-hidden h-auto' : 'relative overflow-hidden h-auto'"
>
  @if(visibility){
  <div class="app__centered-item justify-between mb-[-5px]">
    <h4 class="app__form--attribute--title text-base font-semibold leading-[22px] text-[#1E1E20]">
      <span>{{ data.origin !== 'MxFinancialAccount' ? 'Add new' : null }} {{ data.title }}</span>
    </h4>
    <div class="app__close--icon mt-[-37px] mr-[-16px]">
      <button class="hover:cursor-pointer" matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons text-[#898F9E] text-[24px] leading-7 font-bold">clear</span>
      </button>
    </div>
  </div>
  <hr class="mx-[-26px]" />
  @if(CurrentStep == 2 ){ @if(data.origin !=='MxFinancialAccount'){
  <div class="flex justify-between">
    <p style="text-transform: capitalize" class="pr-3 pt-2 pb-2 sm:mb-0 text-sm font-bold">Which vault should this go in?</p>
    <p class="flex m-0 pt-4">
      <span [class]="'block w-[70px] h-[0.3rem] bg-[#7E9BD4] rounded-lg  mr-2'"> </span>
      <span [class]="'w-[70px] h-[0.3rem] rounded-lg bg-[#25508E] '"> </span>
    </p>
  </div>
  }
  <button (click)="showDropDown = true" class="mt-2 mb-2 h-12 text-[#25508E] text-xs border rounded bg-white">
    <div class="flex justify-between">
      <p class="m-0 leading-8">{{ selected_vault ? selected_vault?.name : 'Select' }}</p>
      <span
        (click)="selected_vault = ''"
        style="transform: rotate(90deg)"
        class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer font-normal"
        >arrow_forward_ios</span
      >
    </div>
  </button>
  @if(showDropDown){
  <div class="search__template d-flex">
    <div class="app__discovery--header--search--field bg-[#FFFFFF]">
      <div class="w-full h-full px-5" style="display: flex; align-items: center; justify-content: space-between">
        <div>
          <span> <img src="assets/images/blue-search-icon.svg" /> </span>
          <input
            #templateSearchInput
            type="text"
            matInput
            [(ngModel)]="searchTextType"
            autofocus
            placeholder="Search Vaults"
            (input)="searchTemplatetype(templateSearchInput.value)"
            (click)="searchTemplate(templateSearchInput.value)"
            class="outline-none ml-1"
          />
        </div>
        <span
          (click)="$event.stopPropagation(); clearAddedShortcut()"
          class="material-icons relative bg-white text-[#898F9E] text-2xl hover:cursor-pointer font-normal"
          >clear</span
        >
      </div>
    </div>
  </div>
  <div style="position: fixed">
    <div
      class="template absolute w-[576px] border overflow-auto bg-white max-h-[148px] h-auto p-3 rounded"
      [ngClass]="{
        'top-[177px]': data.origin == 'MxFinancialAccount',
        'top-[212px]': data.origin !== 'MxFinancialAccount'
      }"
    >
      <div class="task__forms" #formDropdown>
        <div class="task__forms-list">
          <p style="color: rgb(198, 193, 193); font-size: 15px" *ngIf="(vault_list | filterVaultListName : searchTextType)?.length == 0">
            No results found
          </p>
          <ul *ngFor="let vault of vault_list | filterVaultListName : searchTextType" class="mb-3">
            <li class="d-flex justify-content-between cursor-pointer" (click)="selectFormForTypeTask(vault)">
              <div class="d-flex list-container">
                <img [src]="'assets/images/' + vault?.type + '-small.svg'" class="h-10 w-10 rounded p-2 bg-[#EBF0FA]" />
                <div class="pl-3 flex items-start justify-start flex-col">
                  <p class="form-name mb-0 text-xs font-semibold text-[#18191C]">
                    {{ screenWidth > 480 ? (vault?.name | truncateStrPipe : 120) : (vault?.name | truncateStrPipe : 120) }}
                  </p>
                  <span class="paragraph__medium text-[10px] font-medium text-[#707070]"> {{ vault?.type | capitalizeFirstWord }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  } }@else{
  <div class="flex justify-between">
    <p style="text-transform: capitalize" class="pr-3 pt-2 pb-2 sm:mb-0 text-sm font-bold">General Information</p>
    <p class="flex m-0 p-4" style="padding-right: 0px !important">
      <span [class]="'w-[70px] h-[0.3rem] rounded-lg bg-[#25508E] mr-2'"> </span>

      <span [class]="'block w-[70px] h-[0.3rem] bg-[#DCDCDC] rounded-lg  '"> </span>
    </p>
  </div>

  } } @if(!visibility){
  <div class="loader-container" style="width: 90%; margin: auto; flex-direction: column">
    @for (item of loadingItems; track item) {
    <div>
      <div class="flex loader-body" id="{{ item.id }}" style="width: 100%">
        <div class="ph-item width-100per loader-body-item" style="padding: 18px 12px 9px 12px">
          <div class="ph-col-12" style="padding: 0px !important">
            <div class="ph-row">
              <div class="ph-col-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  } @if (formData?.length) {
  <div
    [ngClass]="{ invisible: !visibility || CurrentStep == 2 }"
    [style.height]="visibility && CurrentStep == 1 ? 'auto !important' : '0px !important'"
  >
    <edit-template-basic-form [Form1]="formData" (moveToNextStep)="moveToNextStep()" [documentForm]="documentForm"> </edit-template-basic-form>
  </div>
  } @if(visibility){

  <hr class="mx-[-26px] my-1" />
  <div class="w-full flex justify-end">
    <button
      [ngClass]="{ hidden: showDropDown }"
      [class.disable-button-continue]="CurrentStep == 2 && !selected_vault"
      style="margin-top: 12px !important"
      class="w-[102px] font-semibold sm:py-[7px] py-[7px] sm:text-[13px] text-[13px] m-0 max-[480px]:m-0 app__btn--primary"
      (click)="updateFormTemplateData()"
    >
      {{ CurrentStep == 2 ? 'Save' : 'Continue' }}
    </button>
  </div>
  }
</div>
